










































































import ModalTabMixin from '@/mixins/modal-tab.mixin';
import { IWidgetInjection } from '@resclick/data-access';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import Modal from './injections.modal.vue';
import { i18n } from '@/i18n';
import TableMixin from '@/mixins/table.mixin';

@Component({
  components: {
    Modal,
  },
})
export default class InjectionsTab extends Mixins(ModalTabMixin, TableMixin) {
  @Prop({ required: true }) propertyId!: string;
  @Prop({ required: true }) widgetId!: string;

  columns = [
    {
      label: 'GENERAL.STATUS',
      name: 'isActive',
      sortable: true,
      align: 'center',
    },
    {
      label: 'GENERAL.NAME',
      name: 'name',
      sortable: true,
    },
    {
      label: 'GENERAL.TYPE',
      name: 'type',
      sortable: true,
      field: (row: IWidgetInjection) => {
        let key: string = row.type;
        if (row.type === 'JAVASCRIPT') key = 'CUSTOM_SCRIPT';
        if (row.type === 'CSS') key = 'CUSTOM_CSS';

        return row.type && i18n.tc('GENERAL.' + key);
      },
    },

    {
      label: 'GENERAL.LOCATIONS',
      name: 'locations',
      sortable: true,
      field: (row: IWidgetInjection) => row.locations?.map((location) => i18n.tc('GENERAL.' + location)).join(', '),
    },

    { label: 'GENERAL.ACTIONS', name: 'actions', align: 'center' },
  ];

  modal = {
    open: false,
    id: '',
  };
  //
  // showDialog(id: string) {
  //   this.modal.open = true;
  //   this.
  // }
}
